// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementPresetDraganddropTemplatesResult = arrayOf(
  objectOf({
    id: string,
    name: string,
    thumbnail_image_url: string,
    is_dnd_template: boolean,
  })
);
